import {
  addDoc,
  arrayUnion,
  collection,
  deleteDoc,
  doc,
  getDocs,
  increment,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { mapPlaceNoteDocumentToPlaceNote } from "../lib/map-place-note-document-to-place-note";
import {
  PLACE_NOTE_COLLECTION,
  PlaceNote,
  PlaceNoteDocument,
} from "../types/PlaceNote";
import { debugLogError } from "../utils/debug-log-error";

export async function createPlaceNote(
  placeNoteDocument: Partial<PlaceNoteDocument>
): Promise<void> {
  try {
    const placeNoteRef = collection(firestore, PLACE_NOTE_COLLECTION);
    await addDoc(placeNoteRef, placeNoteDocument);
  } catch (err) {
    debugLogError("createPlaceNote", err);
    throw err;
  }
}

export async function getPlaceNotes(placeId: string): Promise<PlaceNote[]> {
  try {
    const placeNotesRef = collection(firestore, PLACE_NOTE_COLLECTION);
    const q = query(placeNotesRef, where("placeId", "==", placeId));
    const querySnapshot = await getDocs(q);
    const placeNotes: PlaceNote[] = [];
    querySnapshot.forEach((doc) => {
      const placeNote = doc.data() as PlaceNoteDocument;
      placeNote.id = doc.id;
      placeNotes.push(mapPlaceNoteDocumentToPlaceNote(placeNote));
    });
    return placeNotes;
  } catch (err) {
    debugLogError("getPlaceNotes", err);
    throw err;
  }
}

export async function updateNoteUpvotes(
  noteId: string,
  userId: string
): Promise<void> {
  try {
    const noteRef = doc(firestore, PLACE_NOTE_COLLECTION, noteId);
    await updateDoc(noteRef, {
      upvotes: increment(1),
      voterUserIds: arrayUnion(userId),
    });
  } catch (err) {
    debugLogError("updateNoteUpvotes", err);
    throw err;
  }
}

export async function deletePlaceNote(noteId: string): Promise<void> {
  try {
    const noteRef = doc(firestore, PLACE_NOTE_COLLECTION, noteId);
    await deleteDoc(noteRef);
  } catch (err) {
    debugLogError("deletePlaceNote", err);
    throw err;
  }
}
